import React from 'react';
import FileInput from 'components/Input/FileInput';
import AddressInput from './AddressInput';
import {
    FormControl,
    Input,
    FormLabel,
    Checkbox,
    HStack,
    Button,
    VStack,
    FormErrorMessage,
    InputGroup,
    InputLeftElement
} from '@chakra-ui/react';
import { Formik, Form, useField } from 'formik';
import { errorToast, REALTOR_COMPANY_DEFAULTS } from 'constants/index';
import { useUpdateRealtorCompanyMutation } from 'reducers/realtor.service';
import { isFile } from 'utils';

const TextField = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <FormControl isInvalid={meta.touched && !!meta.error} mb={4}>
            <FormLabel>{label}</FormLabel>
            <InputGroup>
                {label === 'Website' && (
                    <InputLeftElement width={'4rem'} pointerEvents="none">
                        <p style={{ paddingLeft: '1.25rem', paddingRight: '1.25rem' }}>https://</p>
                    </InputLeftElement>
                )}
                <Input pl={label === 'Website' ? '4rem' : undefined} {...field} {...props} />
            </InputGroup>
            {/* <Input startElement={ label === 'website' ? <p>HTTPS</p> : null} {...field} {...props} /> */}
            <FormErrorMessage>{meta.error}</FormErrorMessage>
        </FormControl>

    );
};

export default function RealtorCompanyForm({ defaultValues = REALTOR_COMPANY_DEFAULTS, data, setisEdit, refetch }) {
    const [file, setfile] = React.useState(null);
    const [updateCompany, { isLoading }] = useUpdateRealtorCompanyMutation();

    const initialValues = React.useMemo(() => ({
        ...defaultValues,
        ...(data && {
            companyName: data.companyName || '',
            website: data.website || '',
            companytext: data.companytext || '',
            isAddressSameAsRealtor: data.isAddressSameAsRealtor || false,
            Address1: data.Address1 || defaultValues.Address1,
            Address2: data.Address2 || defaultValues.Address2
        })
    }), [data, defaultValues]);

    const handleUpdate = (values) => {
        if (!file) {
            errorToast('Company logo required.');
            return;
        }
        let formData = new FormData();
        let Address1 = JSON.stringify(JSON.stringify(values.Address1));
        let Address2 = JSON.stringify(JSON.stringify(values.Address2));
        formData.append('email', values.email || '');
        formData.append('phoneNumber', values.phoneNumber || '');
        formData.append('companyName', values.companyName || '');
        formData.append('website', values.website || '');
        formData.append('isAddressSameAsRealtor', values.isAddressSameAsRealtor || false);
        formData.append('Address1', Address1);
        formData.append('Address2', Address2);
        formData.append('companytext', values.companytext || '');
        if (isFile(file)) {
            formData.append('logo', file);
        }
        updateCompany({ id: data?._id, body: formData }).unwrap().then(()=>{
            setisEdit(false);
            refetch();
        });
    };

    const handleRemove = () => {
        setfile(null);
    };

    return (
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={handleUpdate}
                enableReinitialize
            >
                {({ values, handleSubmit, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        <VStack align="stretch" spacing={4}>
                            <TextField name="companyName" label="Company Name" />
                            <TextField name="website" label="Website" />
                            <TextField name="companytext" label="Bio" />
                            <FormControl>
                                <Checkbox
                                    name="isAddressSameAsRealtor"
                                    onChange={(e) => {
                                        setFieldValue('isAddressSameAsRealtor', e.target.checked);
                                    }}
                                    isChecked={values.isAddressSameAsRealtor}
                                    colorScheme="brandScheme"
                                >
                                    Is Address Same As Realtor
                                </Checkbox>
                            </FormControl>
                            {!values.isAddressSameAsRealtor && <AddressInput showFirstAddress={true} name="Address2" />}

                            <FileInput
                                handleRemove={handleRemove}
                                label="Logo"
                                required={true}
                                title="Please upload company logo here"
                                setfile={setfile}
                                file={file}
                                data={data}
                            />
                            <HStack justify="flex-end" gap="0.5rem">
                                <Button variant="outline" type="reset" onClick={setisEdit}>
                                    Cancel
                                </Button>
                                <Button disabled={isLoading} colorScheme="blue" type="submit">
                                    {isLoading ? 'Saving...' : 'Save'}
                                </Button>
                            </HStack>
                        </VStack>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
